module.exports = __webpack_public_path__ + "static/media/wordpress-ai-br.0e35b4a3.png";